import React, { Component } from 'react';
import ReactTooltip from 'react-tooltip';

import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css'; // Core styles
import 'ag-grid-community/styles/ag-theme-balham.css'; // Optional theme
import './ag-theme-ela.css';

import * as CellRenderers from './AgGridCellRendererComponents';

const DEFAULT_MIN_WIDTH_CELL = 10;
const DEFAULT_MAX_WIDTH_CELL = 800;

const defaultColDef = {
  resizable: true,
  sortable: true,
  filter: true,
  minWidth: DEFAULT_MIN_WIDTH_CELL,
  maxWidth: DEFAULT_MAX_WIDTH_CELL,
  cellStyle: {
    borderRight: '1px solid #ccc', // Adds a light gray divider
  },
};

const columns = [
  {
    headerName: 'Job#',
    field: 'jobNum',
    cellRenderer: 'jobNumCellRenderer',
    cellRendererParams: { context: { componentParent: this } },
    width: 65,
  },
  {
    headerName: 'Job Type',
    field: 'appointmentTypeId',
    cellRenderer: 'jobTypeCellRenderer',
    width: 90,
  },
  {
    headerName: 'Int Conf?',
    field: 'intConf',
    cellRenderer: 'intConfCellRenderer',
    width: 120,
  },
  {
    headerName: 'Pro conf',
    field: 'provConfFlg',
    cellRenderer: 'provConfCellRenderer',
    width: 65,
  },
  {
    headerName: 'Rep Auth',
    field: 'repAuthorizedFlg',
    cellRenderer: 'repAuthorizedCellRenderer',
    width: 65,
  },
  {
    headerName: 'Clm Conf',
    field: 'clmConfFlg',
    cellRenderer: 'clmConfCellRenderer',
    width: 65,
  },
  {
    headerName: 'Rem Conf',
    field: 'remFinalFlg',
    cellRenderer: 'remFinalConfCellRenderer',
    width: 65,
  },
  { headerName: 'Rem Type', field: 'remTypeDesc', width: 65 },
  {
    headerName: 'T',
    field: 'transportationFlg',
    cellRenderer: 'transportationCellRenderer',
    width: 20,
  },
  {
    headerName: 'Date',
    field: 'jobDateTime',
    cellRenderer: 'jobDateCellRenderer',
    width: 80,
  },
  {
    headerName: 'Claimant',
    field: 'clmLastName',
    cellRenderer: 'claimantNameCellRenderer',
    width: 125,
  },
  {
    headerName: '',
    field: 'jobNotes',
    cellRenderer: 'jobNotesCellRenderer',
    width: 20,
  },
  { headerName: 'CLM Phone', field: 'clmPhone', width: 80 },
  {
    headerName: '',
    field: 'intEmail',
    cellRenderer: 'intEmailCellRenderer',
    width: 30,
  },
  {
    headerName: 'Interpreter',
    field: 'intLastName',
    cellRenderer: 'intNameCellRenderer',
    width: 125,
  },
  { headerName: 'Int Cell /Text', field: 'intCellTxt', width: 80 },
  {
    headerName: 'Job Provider',
    field: 'providerName',
    cellRenderer: 'providerNameCellRenderer',
    width: 125,
  },
  { headerName: 'FU', field: 'fu', cellRenderer: 'fuCellRenderer', width: 50 },
  {
    headerName: 'Rep',
    field: 'repLastName',
    cellRenderer: 'repNameCellRenderer',
    width: 125,
  },
  { headerName: 'Rep Phone', field: 'repPhone', width: 80 },
  { headerName: 'Client Ph', field: 'clientPhone', width: 80 },
  { headerName: 'Client', field: 'clientAbbrv', width: 68 },
  { headerName: 'Caller Notes', field: 'callerNote', width: 125 },
];

export class WorkOrderTableFinalConfirmation extends Component {
  static displayName = WorkOrderTableFinalConfirmation.name;

  constructor(props) {
    super(props);
    this.gridApi = null;
    this.gridColumnApi = null;
    this.previousSelection = [];
    this.state = {
      columnWidths: columns.reduce((acc, col) => {
        acc[col.field] = col.width || DEFAULT_MIN_WIDTH_CELL; // Initialize widths
        return acc;
      }, {}),
      isResizing: -1,
      jobTypeList: JSON.parse(localStorage.getItem('JobTypes')),
    };

    this.autoSizeUnspecifiedColumns =
      this.autoSizeUnspecifiedColumns.bind(this);
    this.adjustHeaderHeight = this.adjustHeaderHeight.bind(this);
    this.handleRowDoubleClick = this.handleRowDoubleClick.bind(this);
    this.onSelectionChanged = this.onSelectionChanged.bind(this);
    this.onGridReady = this.onGridReady.bind(this);
    this.onDataLoaded = this.onDataLoaded.bind(this);
    this.onColumnResized = this.onColumnResized.bind(this);
    this.onSortChanged = this.onSortChanged.bind(this);
  }

  componentDidMount() {
    ReactTooltip.rebuild();
  }

  getSnapshotBeforeUpdate(prevProps) {
    if (prevProps.workOrders !== this.props.workOrders && this.gridApi) {
      return this.gridApi.getFilterModel();
    }
    return null;
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (snapshot !== null && this.gridApi) {
      this.gridApi.setFilterModel(snapshot);
    }
  }

  autoSizeUnspecifiedColumns = () => {
    const allColumnIds = [];
    this.gridColumnApi.getColumns().forEach((column) => {
      // Check if the width is not set in the column definition
      if (column.getColDef().width === undefined) {
        allColumnIds.push(column.colId);
      }
    });
    if (allColumnIds.length > 0) {
      this.gridColumnApi.autoSizeColumns(allColumnIds, false);
    }
  };

  handleRowDoubleClick = (event) => {
    const workorder = event.data;
    const rowIndex = event.rowIndex;
    this.props.setData(workorder, rowIndex, true);
  };

  adjustHeaderHeight = (gridApi) => {
    window.requestAnimationFrame(() => {
      const allColumnHeaders = document.querySelectorAll(
        '.ag-header-cell-text'
      );
      let maxHeight = 0;
      allColumnHeaders.forEach((header) => {
        // Ensure that you have access to the clientHeight property correctly
        if (header.parentElement.clientHeight > maxHeight) {
          maxHeight = header.parentElement.clientHeight;
        }
      });

      // Adding some padding or extra space if necessary
      maxHeight += 10; // Adjust this value based on your CSS and padding needs

      // Directly set the new header height
      gridApi.setHeaderHeight(maxHeight);
    });
  };

  onSelectionChanged = () => {
    const currentSelection = this.gridApi.getSelectedRows();
    const currentSelectionIds = currentSelection.map((item) => item.jobId);
    const previousSelectionIds = this.previousSelection.map(
      (item) => item.jobId
    );

    const newlySelected = currentSelection.filter(
      (node) => !previousSelectionIds.includes(node.jobId)
    );
    const newlyDeselected = this.previousSelection.filter(
      (node) => !currentSelectionIds.includes(node.jobId)
    );

    // Handling changes based on newly selected or deselected
    newlySelected.forEach((node) => {
      const syntheticEvent = {
        target: {
          name: 'chk_' + node.jobNum,
          checked: true,
        },
      };
      this.props.handleCheckChange(syntheticEvent);
    });

    newlyDeselected.forEach((node) => {
      const syntheticEvent = {
        target: {
          name: 'chk_' + node.jobNum,
          checked: false,
        },
      };
      this.props.handleCheckChange(syntheticEvent);
    });

    // Update the previous selection with current
    this.previousSelection = [...currentSelection];
  };

  onGridReady = (params) => {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    if (this.props.onGridReady) {
      this.props.onGridReady(params);
    }
    this.adjustHeaderHeight(params.api);
    this.autoSizeUnspecifiedColumns();
  };

  onDataLoaded = (newData) => {
    this.gridApi.setRowData(newData);
    this.autoSizeUnspecifiedColumns(true);
  };

  onColumnResized = (params) => {
    if (params.finished) {
      // Update the state with new column width
      const newWidths = { ...this.state.columnWidths };
      params.columns.forEach((column) => {
        newWidths[column.getColId()] = column.getActualWidth();
      });
      this.setState({ columnWidths: newWidths }, () => {
        // Call adjustHeaderHeight after state update to ensure it uses the latest widths
        this.adjustHeaderHeight(this.gridApi);
      });
    }
  };

  onSortChanged = () => {
    if (!this.gridApi || typeof this.props.onSortedData !== 'function') {
      return;
    }

    const rowCount = this.gridApi.getDisplayedRowCount();
    const sortedRows = [];
    for (let i = 0; i < rowCount; i += 1) {
      const rowNode = this.gridApi.getDisplayedRowAtIndex(i);
      if (rowNode && rowNode.data) {
        sortedRows.push(rowNode.data);
      }
    }

    this.props.onSortedData(sortedRows);
  };

  render() {
    const gridOptions = {
      suppressSizeToFit: true,
      columnDefs: columns,
      rowData: Array.isArray(this.props.workOrders)
        ? this.props.workOrders
        : [],
      context: {
        componentParent: this,
        handleCheckChange: this.props.handleCheckChange,
        gridApi: this.gridApi,
        addSchedule: this.props.addSchedule,
        setModal: this.props.setModal,
        setInterpreterEmail: this.props.setInterpreterEmail,
        onChange: this.props.handleCheckChange,
        state: this.props.state,
      },
      animateRows: true,
      defaultColDef: defaultColDef,
      components: {
        jobNumCellRenderer: CellRenderers.JobNumCellRenderer, // Register the cell renderer
        jobTypeCellRenderer: CellRenderers.JobTypeCellRenderer,
        intConfCellRenderer: CellRenderers.IntConfCellRenderer,
        provConfCellRenderer: CellRenderers.ProvConfCellRenderer,
        repAuthorizedCellRenderer: CellRenderers.RepAuthorizedCellRenderer,
        clmConfCellRenderer: CellRenderers.ClmConfCellRenderer,
        remFinalConfCellRenderer: CellRenderers.RemFinalConfCellRenderer,
        transportationCellRenderer: CellRenderers.TransportationCellRenderer,
        jobDateCellRenderer: CellRenderers.JobDateCellRenderer,
        claimantNameCellRenderer: CellRenderers.ClaimantNameCellRenderer,
        jobNotesCellRenderer: CellRenderers.JobNotesCellRenderer,
        intEmailCellRenderer: CellRenderers.IntEmailCellRenderer,
        intNameCellRenderer: CellRenderers.IntNameCellRenderer,
        providerNameCellRenderer: CellRenderers.ProviderNameCellRenderer,
        repNameCellRenderer: CellRenderers.RepNameCellRenderer,
        fuCellRenderer: CellRenderers.FuCellRenderer,
      },
      rowSelection: 'single',
      onRowClicked: this.onRowClicked,
      onColumnResized: this.onColumnResized,
      onSortChanged: this.onSortChanged,
      rowHeight: 20,
      tooltipShowDelay: 0,
      enableBrowserTooltips: true,
      onRowDoubleClicked: this.handleRowDoubleClick,
      onSelectionChanged: this.onSelectionChanged,
    };

    return (
      <div
        className="ag-theme-balham"
        style={{
          width: '100%',
          height: '600px',
        }}
      >
        <AgGridReact
          {...gridOptions}
          onGridReady={this.onGridReady}
          rowSelection={'multiple'}
        />
      </div>
    );
  }
}
